import { render, staticRenderFns } from "./identificacaoVoo.vue?vue&type=template&id=2c0b7e46"
import script from "./identificacaoVoo.vue?vue&type=script&lang=js"
export * from "./identificacaoVoo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports